<div *ngIf="aboutHTML.hardwareInformation" myPluginSelector pluginSelectorId="about-instance-other-information">
  <h4 i18n class="section-title">Hardware information</h4>
  <div [innerHTML]="aboutHTML.hardwareInformation"></div>
</div>

<div myPluginSelector pluginSelectorId="about-instance-features">
  <h4 class="visually-hidden" i18n>FEATURES</h4>
  <my-instance-features-table></my-instance-features-table>
</div>

